import HouseholdComponent from './household.js';
import './App.css';
import { useState, useEffect, } from 'react';
import logo from './village.jpeg';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';

const AuthCallbackPage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const authCode = urlParams.get("code");
    const navigate = useNavigate();
    var callbackUrl = ''
    if (process.env.REACT_APP_API_BASE_URL == 'http://localhost:3000') {
        callbackUrl = 'http://localhost:3000/authCallbackLocal'
    } else {
        callbackUrl = 'https://koy.parent-ai.com/authCallback/'
    }
    const data = new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
        code: authCode,
        redirect_uri: callbackUrl,
    });

    const loadingAndLoaded = [false, false];
    useEffect(() => {
        if (!loadingAndLoaded[0] && !loadingAndLoaded[1]) {
            loadingAndLoaded[0] = true;
            fetch(`https://${process.env.REACT_APP_COGNITO_HOSTED_AUTH_DOMAIN}/oauth2/token`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: data,
            })
                .then(response => response.json())
                .then(json => {
                    console.log(json);                    
                    // Store the tokens in a cookie or other storage mechanism
                    if (process.env.REACT_APP_API_BASE_URL == 'http://localhost:3000') {
                        document.cookie = `access_token=${json.access_token}; Secure; SameSite=None; Expires=Tue, 01 Dec 2025 23:59:59 GMT; Path=/;`;
                        document.cookie = `refresh_token=${json.refresh_token}; Secure; SameSite=None; Expires=Tue, 01 Dec 2025 23:59:59 GMT; Path=/`;
                    } else {
                    document.cookie = `access_token=${json.access_token}; Secure; SameSite=None; Expires=Tue, 01 Dec 2025 23:59:59 GMT; Path=/; Domain=parent-ai.com`;
                    document.cookie = `refresh_token=${json.refresh_token}; Secure; SameSite=None; Expires=Tue, 01 Dec 2025 23:59:59 GMT; Path=/; Domain=parent-ai.com`;
                    }
                    loadingAndLoaded[1]=true;
                    navigate('/');
                })
        }
    }, []); // Pass an empty array as the dependency list to run the effect only on mount

    console.log(authCode);

    return (
        <div className="App">
            <div className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
            </div>
            <div className="App-body App-body-center">
                <div>
                    <p>Placeholder</p>
                </div>
            </div>
        </div>
    );
}

export default AuthCallbackPage;
/*
curl --location --request POST 'https://login.parent-ai.com/oauth2/token' \
--header 'Content-Type: application/x-www-form-urlencoded' \
--data-urlencode 'grant_type=authorization_code' \
--data-urlencode 'client_id=h6g6mnknddkrthbbp5iq66jdg' \
--data-urlencode 'code=a992b287-b910-478b-8806-ffa67543a63d' \
--data-urlencode 'redirect_uri=http://localhost:3000'
*/

                    
                    //
